import React, { useEffect } from 'react';
import { useJwtAuth } from './useJwtLogin';

type Props = {
  authorizationCode: string;
};

const LoginWithAuthorizationCode: React.FC<Props> = ({ authorizationCode }) => {
  const { doLoginByAuthorizationCode } = useJwtAuth();

  useEffect(() => {
    doLoginByAuthorizationCode(authorizationCode);
  }, [doLoginByAuthorizationCode, authorizationCode]);

  return <></>;
};

export default LoginWithAuthorizationCode;
